// Logo SVG personalizzato: lampadina con foglia verde (richiama il design originale)
export const BrandLogo = ({ className = "w-7 h-7" }) => (
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <radialGradient id="bulbGlow" cx="50%" cy="40%" r="60%">
        <stop offset="0%" stopColor="#fff7c2" />
        <stop offset="60%" stopColor="#ffd96b" />
        <stop offset="100%" stopColor="#e0a800" />
      </radialGradient>
      <linearGradient id="leafGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#34d399" />
        <stop offset="100%" stopColor="#10b981" />
      </linearGradient>
    </defs>
    {/* Bulb glass */}
    <path
      d="M32 6c-10 0-17 7.4-17 16.6 0 5.7 2.7 9.9 6 13.4 2.4 2.4 3.5 4.8 3.5 7.5v3.2c0 1.2 1 2.2 2.2 2.2h10.6c1.2 0 2.2-1 2.2-2.2v-3.2c0-2.7 1.1-5.1 3.5-7.5 3.3-3.5 6-7.7 6-13.4C49 13.4 42 6 32 6z"
      fill="url(#bulbGlow)"
      opacity="0.95"
    />
    {/* Bulb glass outline */}
    <path
      d="M32 6c-10 0-17 7.4-17 16.6 0 5.7 2.7 9.9 6 13.4 2.4 2.4 3.5 4.8 3.5 7.5v3.2c0 1.2 1 2.2 2.2 2.2h10.6c1.2 0 2.2-1 2.2-2.2v-3.2c0-2.7 1.1-5.1 3.5-7.5 3.3-3.5 6-7.7 6-13.4C49 13.4 42 6 32 6z"
      fill="none"
      stroke="#0f172a"
      strokeWidth="1.5"
    />
    {/* Leaf inside bulb */}
    <path
      d="M22 26c0-7 6-12 13-12 1 6-2 11-7 13-3 1-5 1-6-1z"
      fill="url(#leafGrad)"
    />
    <path
      d="M28 22c2-1 5-1 7 0M27 25c2-1 5-1 7 0"
      stroke="#065f46"
      strokeWidth="0.8"
      strokeLinecap="round"
      fill="none"
      opacity="0.6"
    />
    {/* Second leaf */}
    <path
      d="M42 23c-1 5-5 8-9 9 0-5 3-9 7-10 1 0 2 0 2 1z"
      fill="url(#leafGrad)"
      opacity="0.85"
    />
    {/* Screw base */}
    <rect x="25" y="49" width="14" height="3" rx="1" fill="#475569" />
    <rect x="26.5" y="52" width="11" height="2.5" rx="0.5" fill="#334155" />
    <rect x="28" y="54.5" width="8" height="2.5" rx="0.5" fill="#475569" />
    <path d="M29 57h6l-1 2h-4z" fill="#1e293b" />
  </svg>
);
